'use strict';

function TransactionFilterModel(ModelFactory,
                                $rootScope,
                                TransactionTabFilterModel,
                                userPreferenceDateFormatFilter) {
  var filterModel = ModelFactory.create('TransactionFilterModel', [
    'filter',
    'filterByExceptionFlag',
    'transactions',
    'fields'
  ]);

  var RELEVANT_FILTERS = [];

  filterModel.filter('');
  filterModel.transactions([]);
  filterModel.filterByExceptionFlag(false);
  filterModel.fields([]);

  filterModel.onFilterChanged($rootScope, onTransactionsOrFilterChanged);
  filterModel.onFilterByExceptionFlagChanged($rootScope, onTransactionsOrFilterChanged);
  TransactionTabFilterModel.onTransactionsChanged($rootScope, onTransactionsOrFilterChanged);

  filterModel.onFieldsChanged($rootScope, function () {
    RELEVANT_FILTERS = getSelectedFilters();
  });

  filterModel.isFilterEnabled = function () {
    return !_.isEmpty(filterModel.filter()) || filterModel.filterByExceptionFlag();
  };

  function onTransactionsOrFilterChanged() {
    filterModel.transactions(applyFilter(TransactionTabFilterModel.transactions()));
  }

  function exceptionFlagFilter(transaction) {
    if(!filterModel.filterByExceptionFlag()) { return true; }

    return _.get(transaction,'details.exceptionFlag', false);
  }

  // WITHOUT ACCOUNT FIELDS.
  var FILTERS = {
    'Date': function (transaction) {
      return userPreferenceDateFormatFilter(_.get(transaction, 'date', ''));
    },
    'Cardmember Name and Card Number': function (transaction) {
      return _.toUpper(_.get(transaction, 'cardmemberName', ''));
    },
    'Merchant Name 1': function (transaction) {
      var value = _.head(_.compact([
        _.get(transaction, 'merchantName1', '')
      ]));

      return _.toUpper(value || '');
    },
    'Merchant Name 2': function (transaction) {
      var value = _.head(_.compact([
        _.get(transaction, 'merchantName2', '')
      ]));

      return _.toUpper(value || '');
    },
    'Merchant Location': function (transaction) {
      var value = _.head(_.compact([
        getAddress(transaction)
      ]));

      return _.toUpper(value || '');
    },
    'Traveler Name': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.travelerName', ''));
    },
    'Ticket Number': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.ticketNumber', ''));
    },
    'PO#': function (transaction) {
      return getThirdPartyDataField(transaction, 'poNumber');
    },
    'Amount': function (transaction) {
      var amount = _.get(transaction, 'amount', null);
      return amount !== null ? amount.toFixed(2) : '';
    },
    'Pre Auth Id': function (transaction) {
      if (transaction.preAuthData && transaction.preAuthData.length > 0) {
        return _.toUpper(_.get(transaction.preAuthData[0].id, 'preAuthorizationId', ''));
      } else {
        return '';
      }
    },
    'Cardmember Name': function (transaction) {
      return _.toUpper(_.get(transaction, 'cardmemberName', ''));
    },
    'Transaction Reference Number': function (transaction) {
      return _.get(transaction, 'transRefNo', '');
    },
    'Description 1': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.descriptionLine1', ''));
    },
    'Description 2': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.descriptionLine2', ''));
    },
    'Description 3': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.descriptionLine3', ''));
    },
    'Description 4': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.routing', ''));
    },
    'Cardmember Reference 1': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.cardmemberReference1', ''));
    },
    'Cardmember Reference 2': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.travelerName', ''));
    },
    'Cardmember Reference 3': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.cardmemberReference3', ''));
    },
    'Cardmember Reference 4': function (transaction) {
      return _.toUpper(_.get(transaction, 'details.cardmemberReference4', ''));
    },
    'Merchant Reference Number': function (transaction) {
      return _.get(transaction, 'details.merchantReference', '');
    }
  };

  function getAddress(transaction){
    var merchantCity = _.toUpper(_.get(transaction, 'merchantCity', ''));
    var merchantState =  _.toUpper(_.get(transaction, 'merchantState', ''));
    return  merchantCity.trim() + merchantState.trim();
  }

  function getSelectedFilters() {
    var filterList = [];

    _.forEach(filterModel.fields(), function (filterName) {
      if (FILTERS[filterName] === undefined || FILTERS[filterName] === null) { // Account Fields
        filterList.push(
            function (transaction) {
              var position = Number(filterName);
              return position === -1 ? getAccountingFieldDescription(transaction) : getAccountingFieldValue(transaction, position);
            }
        );
      } else {
        filterList.push(FILTERS[filterName]);
      }
    });

    return filterList;
  }

  function getAccountingFieldValue(transaction, position) {
    var accountingFieldValues = _.get(transaction, 'allocations[0].accountingFieldValues', []);
    var accountingFieldValue = _.find(accountingFieldValues, { 'position': position });

    if (accountingFieldValue) {
      return _.toUpper(accountingFieldValue.value);
    } else {
      return '';
    }
  }

  function getAccountingFieldDescription(transaction) {
    return _.toUpper(_.get(transaction, 'allocations[0].description',''));
  }

  function getThirdPartyDataField(transaction, fieldName) {
    if(transaction.transactionThirdPartyData && transaction.transactionThirdPartyData.length > 0) {
      return _.toUpper(_.get(transaction.transactionThirdPartyData[0], fieldName, ''));
    } else {
      return '';
    }
  }

  function applyFilter(transactions) {
    var filter = filterModel.filter();
    if (_.isEmpty(filter) && !filterModel.filterByExceptionFlag()) {
      return transactions;
    }
    return _.filter(transactions, shouldFilterTransaction);
  }

  function shouldFilterTransaction(transaction) {
    var filter = _.toUpper(filterModel.filter());

    if(_.isEmpty(filter)) {
      return exceptionFlagFilter(transaction);
    }

    return exceptionFlagFilter(transaction) &&
      _.some(RELEVANT_FILTERS, function (func) {
        var value = func(transaction);
        return value.indexOf(filter) > -1;
      });
  }

  return filterModel;
}

angular.module('amexReconciliationApp')
  .service('TransactionFilterModel', TransactionFilterModel);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionFilterModel.js
// module id = 591
// module chunks = 0